import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Achievements from "./components/Achievements";

export default function App() {
  return (
    <main className="text-muted bg-ink">
      <Navbar />
      <About />
      <Achievements />
      <Experience />
      <Projects />
      <Skills />
      <Education />
      <Contact />
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js